import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import IndustrySolutionsSection from './components/IndustrySolutionsSection';
import ROICalculatorSection from './components/ROICalculatorSection';
import SecurityComplianceSection from './components/SecurityComplianceSection';
import DownloadResourcesSection from './components/DownloadResourcesSection';
import ClientSuccessSection from './components/ClientSuccessSection';
import CTASection from './components/CTASection';

const EnterpriseSolutions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFBFC] flex flex-col">
      <Header />
      
      <main className="flex-1 pt-16">
        <HeroSection />
        <IndustrySolutionsSection />
        <ROICalculatorSection />
        <SecurityComplianceSection />
        <DownloadResourcesSection />
        <ClientSuccessSection />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
};

export default EnterpriseSolutions;